import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiServiceService } from 'src/app/Services/api-service.service';

@Component({
  selector: 'app-verification-landing',
  templateUrl: './verification-landing.component.html',
  styleUrls: ['./verification-landing.component.css']
})
export class VerificationLandingComponent implements OnInit {

  form: any = FormGroup;

  constructor(

    private apiService: ApiServiceService,
    private router: Router,
    private fb: FormBuilder,

  ) { }

  ngOnInit(): void {

    this.initializeForm()

  }

  initializeForm() {

    this.form = this.fb.group({

      verificationType: ['', [Validators.required]],
      id: ['', [Validators.required]],

    });

  }

  verify() {

    const type: string = this.form.get("verificationType")?.value
    const id: string = this.form.get("id")?.value

    this.router.navigate(['/verification-view/' + type + '/' + id]);

  }



}
